// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__K2oNc","inner":"Banner_inner__Oe8g_","message":"Banner_message__mMQCw","cta":"Banner_cta__d0qdw"};